import { render } from "./TagAutoInputComponent.vue?vue&type=template&id=b4fb72b8&scoped=true"
import script from "./TagAutoInputComponent.vue?vue&type=script&lang=js"
export * from "./TagAutoInputComponent.vue?vue&type=script&lang=js"

import "./TagAutoInputComponent.vue?vue&type=style&index=0&id=b4fb72b8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4fb72b8"]])

export default __exports__